const adviceSize = (
  productType,
  sizeVariants,
  { ankle, calf, lowerLeg, shoe },
  node_locale,
) => {
  switch (productType.name) {
    case 'Half Calf / Crew':
    case 'Knee High':
      const calfVariants_KneeHigh = sizeVariants.filter((variant) =>
        variant.calfRanges.map((range) => range.measurementName).includes(calf),
      )
      const shoeSizes_KneeHigh = calfVariants_KneeHigh[0].calfRanges.find(
        (range) => range.measurementName === calf,
      ).subMeasurements

      const shoeSize_KneeHigh = shoeSizes_KneeHigh.find((size) => {
        switch (node_locale) {
          case 'en-GB':
            return shoe >= size.minValueUk && shoe <= size.maxValueUk
          case 'en-US':
            return shoe >= size.minValueUs && shoe <= size.maxValueUs
          default:
            return shoe >= size.minValue && shoe <= size.maxValue
        }
      })
      return shoeSize_KneeHigh ? shoeSize_KneeHigh.sizeName : null

    case 'Ankle':
      const ankleVariants_Ankle = sizeVariants.filter((variant) =>
        variant.ankleRanges
          .map((range) => ankle >= range.minValue && ankle <= range.maxValue)
          .includes(true),
      )
      const shoeVariants_Ankle = ankleVariants_Ankle.filter((variant) =>
        variant.shoeRanges
          .map((range) => {
            switch (node_locale) {
              case 'en-GB':
                return shoe >= range.minValueUk && shoe <= range.maxValueUk
              case 'en-US':
                return shoe >= range.minValueUs && shoe <= range.maxValueUs
              default:
                return shoe >= range.minValue && shoe <= range.maxValue
            }
          })
          .includes(true),
      )
      return shoeVariants_Ankle[0]
        ? shoeVariants_Ankle.length > 1
          ? shoeVariants_Ankle[1].sizeName
          : shoeVariants_Ankle[0].sizeName
        : null

    case 'Medical Socks Unisex':
      const lowerLegVariants_Medical = sizeVariants.filter((variant) =>
        variant.lowerLegRanges
          .map((range) => range.measurementName)
          .includes(lowerLeg),
      )
      const calfVariants_Medical = lowerLegVariants_Medical.filter((variant) =>
        variant.calfRanges.map((range) => range.measurementName).includes(calf),
      )
      const ankleSize_Medical = calfVariants_Medical.find((variant) =>
        variant.ankleRanges
          .map((range) => ankle >= range.minValue && ankle <= range.maxValue)
          .includes(true),
      )
      return ankleSize_Medical ? ankleSize_Medical.sizeName : null
  }
}

export default adviceSize
